import React, {useEffect} from 'react';
import './App.css';
import {Route, Routes} from "react-router-dom";
import SimulationPage from "./pages/SimulationPage";
import {Provider} from "react-redux";
import {store} from "./store/store";
import InfoPage from "./pages/InfoPage";
import ResultPage from "./pages/ResultPage";
import HomePage from "./pages/HomePage";
import DetailPage from "./pages/DetailPage";
import StatisticsPage from "./pages/StatisticsPage";

function App() {

    return (
        <Provider store={store}>
            <React.Fragment>
                <Routes>
                    <Route path="/" Component={HomePage} />
                    <Route path="/simulation" Component={SimulationPage} />
                    <Route path="/info" Component={InfoPage} />
                    <Route path="/result" Component={ResultPage} />
                    <Route path="/detail" Component={DetailPage} />
                    <Route path="/statistics" Component={StatisticsPage} />
                </Routes>
            </React.Fragment>
        </Provider>
    );
}

export default App;
